///<reference path="CRUD.d.ts"/>

import CRUD from './CRUD';
import Club from '../api/club';

class ClubCrud extends CRUD {
  prefix = 'club';

  get _model() {
    return Club;
  }

}

export default new ClubCrud();



// WEBPACK FOOTER //
// ./src/actions/club.ts